const instructionPackagesColumns = [
  { field: 'name', label: 'ID', searchable: true },
  { field: 'description', label: 'Title', searchable: true },
  {
    field: 'linkedInstructions',
    label: 'Linked Instructions',
    searchable: false,
  },
  { field: 'linkedTasks', label: 'Linked Tasks', searchable: false },
  { field: 'linkedTemplates', label: 'Linked Templates', searchable: false },
  { field: 'date', label: 'Created', searchable: true },
];

export default instructionPackagesColumns;
